import React, { useContext } from "react";
import { ColorSelector } from "../../components/ColorSelector";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";

const colours = [
  { filter: "undoButtonBorderColor", display: "border" },
  { filter: "undoButtonBackgroundColor", display: "background" },
  { filter: "undoButtonIconColor", display: "icon" },
];

const marginTop = 5;

export const UndoButtonFilterPanel = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig } = store;

  const changefilter = (val, key) => {
    const newFilter = { ...flowConfig, [key]: val };
    dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: newFilter });
    dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "block",
      }}
    >
      <div>
        {/* undoButtonPadding */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.undoButtonPadding}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonPadding")
            }
          />
          {`Padding ${flowConfig.undoButtonPadding}`}
        </div>
        {/* undoButtonTop */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={20}
            value={flowConfig.undoButtonTop}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonTop")
            }
          />
          {`Margin Top ${flowConfig.undoButtonTop}`}
        </div>
        {/* undoButtonRight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={20}
            value={flowConfig.undoButtonRight}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonRight")
            }
          />
          {`Margin Right ${flowConfig.undoButtonRight}`}
        </div>
        {/* undoButtonHeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={30}
            value={flowConfig.undoButtonHeight}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonHeight")
            }
          />
          {`Icon Height ${flowConfig.undoButtonHeight}`}
        </div>
        {/* undoButtonWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={30}
            value={flowConfig.undoButtonWidth}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonWidth")
            }
          />
          {`Icon Width ${flowConfig.undoButtonWidth}`}
        </div>
        {/* undoButtonBorderWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={6}
            value={flowConfig.undoButtonBorderWidth}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonBorderWidth")
            }
          />
          {`Border Width ${flowConfig.undoButtonBorderWidth}`}
        </div>{" "}
        {/* undoButtonBorderRadius */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={10}
            value={flowConfig.undoButtonBorderRadius}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "undoButtonBorderRadius")
            }
          />
          {`Border Radius ${flowConfig.undoButtonBorderRadius}`}
        </div>
      </div>
      <ColorSelector
        colours={colours}
        changefilter={changefilter}
        filter={flowConfig}
      />
    </div>
  );
};
